export const BARN_ICON_URL = "/images/optimized/barn-marker-v1.webp";
export const CARROT_ICON_URL = "/images/optimized/carrot-marker-v1.webp";
